import { render, staticRenderFns } from "./ITip.vue?vue&type=template&id=49da1fc7&scoped=true&"
import script from "./ITip.vue?vue&type=script&lang=js&"
export * from "./ITip.vue?vue&type=script&lang=js&"
import style0 from "./ITip.vue?vue&type=style&index=0&id=49da1fc7&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49da1fc7",
  null
  
)

export default component.exports